import EventTypeBadge from './EventTypeBadge';

export default EventTypeBadge;
